import type { HullCleaningVendor } from "../models/hull-cleaning.models";

const normalizeVendorLocation = (value?: string | null) =>
  String(value ?? "")
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");

const vendorMatchesLocation = (vendor: HullCleaningVendor, location: string) => {
  const normalizedLocation = normalizeVendorLocation(location);
  if (!normalizedLocation) return true;

  return [vendor.portName, vendor.place, vendor.city, vendor.country, vendor.region].some((locationValue) => {
    const normalizedVendorLocation = normalizeVendorLocation(locationValue);
    return (
      normalizedVendorLocation.length > 0 &&
      (normalizedVendorLocation.includes(normalizedLocation) || normalizedLocation.includes(normalizedVendorLocation))
    );
  });
};

export const getVendorOptionsForLocation = (vendors: HullCleaningVendor[], location: string) => {
  const seen = new Set<string>();

  return vendors.reduce<string[]>((options, vendor) => {
    const company = vendor.company.trim();
    const companyKey = company.toUpperCase();
    if (!company || seen.has(companyKey) || !vendorMatchesLocation(vendor, location)) {
      return options;
    }

    seen.add(companyKey);
    options.push(company);
    return options;
  }, []);
};
